import React, { useId } from 'react';
import * as styles from './index.styles';

type StarProps = {
  fillBackground: string;
  fillStar: string;
  percentage?: number;
  size?: number;
};

export function Star({
  fillStar,
  fillBackground,
  percentage = 100,
  size = 20,
}: StarProps): JSX.Element {
  const gradientId = useId();
  const fillPercent =
    percentage > 0 && percentage < 1 ? percentage * 100 : percentage;

  return (
    <span css={styles.star(size)}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 16 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Star</title>
        <defs>
          <linearGradient id={gradientId} x1="0" x2="1" y1="0" y2="0">
            <stop offset={`${fillPercent}%`} stopColor={fillStar} />
            <stop offset={`${fillPercent}%`} stopColor={fillBackground} />
          </linearGradient>
        </defs>
        <path
          d="M12.1218 11.6464L15.7416 8.11809L10.739 7.3912C10.5222 7.35963 10.3341 7.22356 10.2371 7.02661L8.00008 2.49341L5.7631 7.02661C5.66609 7.22355 5.47795 7.35961 5.26115 7.39119L0.258545 8.11809L3.87834 11.6464C4.03589 11.7994 4.10751 12.0201 4.0704 12.2366L3.21558 17.2187L7.68954 14.8665C7.88355 14.7642 8.11597 14.7642 8.30998 14.8665L12.7846 17.2187L11.9298 12.2366C11.8927 12.0201 11.9643 11.7994 12.1218 11.6464Z"
          fill={`url(#${gradientId})`}
        />
      </svg>
    </span>
  );
}
